export default __webpack_public_path__ + "static/media/loading.caf132fd.gif";